<template>
    <div class="mybuildingArea">
        <div class="con">
			<div class="con-left">
                <div class="top-tree top-div">
					<div class="Files-top">
						<div class="ic-left">
						<span>通讯设备列表</span>
						</div>
						<div class="btns">
						</div>
					</div>
					<div class="mytree" :style="{'height':heights+'px'}">
							<el-scrollbar style="height:calc(100% - 10px);width: 100%;">
							<el-tree :data="channelAndDeviceTree"   :default-expanded-keys="[2]" default-expand-all :expand-on-click-node="true" 
								:props="defaultProps" :highlight-current='true' show-checkbox ref="tree" @node-click="checkItem">
								<span class="custom-tree-node" slot-scope="{node, data}">
								<img src="../../../public/static/image/elTree/2.0.png" v-show="data.entityName=='Channel'"/>
								<img src="../../../public/static/image/elTree/2.0.png" v-show="!data.entityName"/>
								<img src="../../../public/static/image/elTree/2.1.png" v-show="data.entityName=='Device'"/>
								<span style="padding:0px  5px;">{{node.label }}</span>
								</span>
							</el-tree>
							</el-scrollbar>
					 </div>

				</div>
				<div class="mytable xia-div">
					 <el-table	ref="multipleTable"	:data="nowDeviceVariableList" stripe height="100%" border tooltip-effect="dark" style="width: 100%"
							@selection-change="handleSelectionChange">
							<el-table-column type="selection"	width="44" align="center" fixed></el-table-column>
							<el-table-column	prop="name" label="变量名称" 	width="350"></el-table-column>
							<el-table-column	prop="channelNo"	label="通道号"	width="120"></el-table-column>
							<el-table-column	prop="deviceNo"	label="设备号"	show-overflow-tooltip></el-table-column>
					</el-table>
				</div>
			</div>
			<div class="con-middle">
				<div class="top-btn top-div">
                     <div class="btns">
						  <div class="left-add" @click="addDeviceToRight">导入虚设备<img src="@/assets/right.png"></div>
                          <div class="del" @click="deleteOperate">删除虚设备<img src="@/assets/left.png"></div>
					 </div>
				</div>
				<div class="xia-btn xia-div">
					<div class="btns">
						  <div class="left-add">导入变量<img src="@/assets/right.png"></div>
                          <div class="del">移除点表<img src="@/assets/left.png"></div>
					 </div>
				</div>
			</div>
			<div class="con-right">
				<div class="top-div top-tree">
					<div class="Files-top">
						<div class="ic-left">
						<span>虚拟设备列表</span>
						</div>
						<div class="btns">
                             <el-button type="primary" v-show="isArea" @click='addDevice'>添加设备</el-button>
                             <el-button type="primary" v-show="isArea" @click="addGroup">添加组</el-button>
                             <el-button type="primary" @click="editGroup">修改</el-button>
                             <el-button type="primary" class="last-el-button del-btn-transfer" @click="deleteOperate">删除</el-button>
						</div>
					</div>
					<div class="mytree" :style="{'height':heights+'px'}">
							<el-scrollbar style="height:calc(100% - 10px);width: 100%;">
							<el-tree :data="channelAndVirtualDeviceTree"   :default-expanded-keys="[2]" default-expand-all :expand-on-click-node="false" 
								:props="defaultProps" :highlight-current='true' show-checkbox ref="tree" @node-click="checkItemTwo" >
								<span class="custom-tree-node" slot-scope="{node, data}">
								<img src="../../../public/static/image/elTree/1.9.png" v-show="data.entityName=='AppClassType'&&data.unitid!=''&&data.unitid != null"/>
								<img src="../../../public/static/image/elTree/2.0.png" v-show="data.entityName=='AppClassType'&&(data.unitid=='' || data.unitid == null)"/>
								<img src="../../../public/static/image/elTree/2.0.png" v-show="!data.entityName"/>
								<img src="../../../public/static/image/elTree/2.1.png" v-show="data.type=='virtualDevice'"/>
								<span style="padding:0px  5px;">{{node.label }}</span>
								</span>
							</el-tree>
							</el-scrollbar>
					 </div>
				</div>
				<div class="xia-div mytable">
					 <el-table	ref="multipleTable"	:data="nowDeviceVariableListTwo" stripe height="100%" border	tooltip-effect="dark" style="width: 100%"
					 	@selection-change="handleSelectionChange">
						<el-table-column type="selection"	width="44" align="center" fixed></el-table-column>
						<el-table-column	prop="name" label="变量名称"  width="350"></el-table-column>
						<el-table-column	prop="channelNo"	label="通道号"	width="120"></el-table-column>
						<el-table-column	prop="deviceNo"	label="设备号"	show-overflow-tooltip></el-table-column>
					</el-table>
				</div>
			</div>
		</div>
		
		<!-- 新增修改 -->
		 <el-dialog v-dialogDrag :title="textMap[dialogStatus]" :close-on-click-modal='false' :visible.sync="dialogVisible"
				width="400px" center>
				 <div style="display: flex;">
                    <el-form :model="temp" ref="temp" :rules="rules" style="width: 100%;height: 60px;padding-top: 10px;">
                       <el-form-item label="名称:" prop="name">
							<el-input v-model="temp.name" style=""></el-input>
						</el-form-item>
                    </el-form>
					
                  </div>
				<template #footer>
					<span class="dialog-footer">
					<el-button @click="dialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="dialogStatus==='edit'?edit_fn('temp'):add_fn('temp')">确 定
					</el-button>
					</span>
				</template>
         </el-dialog>
    </div>
</template>

<script>	
import virtualDeviceTree from '@/components/module/tree/virtualDeviceTree.vue'
import iconButton from '@/components/module/universal/iconButton.vue'


export default {
    components: {
		virtualDeviceTree,
        iconButton,
    },
    props: {},
    data() {
        return {
			heights: document.getElementById('app').clientHeight-540,
			channelAndDeviceTree: [],
			channelAndVirtualDeviceTree: [],
			nowDeviceVariableList: [],
			nowDeviceVariableListTwo: [],
			isContainer: false,
			isArea: false,
			nowCheckedItem: undefined,
			newSort: 0,
			defaultProps: {
					children: 'next',
					label: 'name'
				},
				multipleSelection:[],
				 rules: {
			name: [
				{ required: true, message: '请输入名称', trigger: 'blur' }
			],
			},
			dialogVisible: false,
			dialogStatus: '',
			temp: {},
			textMap: {
			addGroup: "添加组",
			addDevice: "添加设备",
			edit: "修改名称",
			},
			lableMap: {
			addGroup: "组名称：",
			addDevice: "设备名称：",
			edit: "新名称：",
			},
			newName:"",
        }
    },
    created() {},
    mounted() {
		this.getChannelAndDeviceTree()
		this.getChannelAndVirtualDeviceTree()
	},
    destroyed() {},
    computed: {
		addedDeviceNos() {
			if(isempty(this.channelAndVirtualDeviceTree)) {
				return []
			}
			var nos = []
			this.getAddedDeviceNos(this.channelAndVirtualDeviceTree, nos)
			return nos.sort()
		}
    },
    watch: {
		
    },
    methods: {
		  handleSelectionChange(val) {
        this.multipleSelection = val;
      },
        //添加组弹窗
		addGroup() {
			   this.dialogStatus = 'addGroup';
				this.dialogVisible = true;
				this.$nextTick(() => {
				this.$refs["temp"].clearValidate();
				});
				this.temp = {};
		},
		// 添加设备弹窗
		addDevice() {
			    this.dialogStatus = 'addDevice';
				this.dialogVisible = true;
				this.$nextTick(() => {
				this.$refs["temp"].clearValidate();
				});
				this.temp = {};
		},
		 // 确认添加
        add_fn(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
		   if(this.dialogStatus == 'addGroup'){
                	this.$api.deviceApi.saveAppClassType(undefined, this.temp.name, this.nowCheckedItem.no, undefined, this.newSort, '0', respon => {
						 this.$message({ showClose: true, message: '添加组：' + respon.name + ' 成功！', type: 'success' });
						this.getChannelAndVirtualDeviceTree()
						this.dialogVisible = false
					}, err => {
						 this.$message({ showClose: true, message:err, type: 'error' });
						this.dialogVisible = false
					})
		   }else {}

          } else {
            return false;
          }
        });
      },
	  //修改弹窗
		editGroup() {
			this.dialogStatus = "edit";
			this.temp = Object.assign({}, this.nowCheckedItem);
			this.dialogVisible = true;
			this.$nextTick(() => {
			this.$refs["temp"].clearValidate();
			});
		},
	    // 确认编辑
      edit_fn() {
        this.$refs['temp'].validate(valid => {
          if (valid) {
            // console.log("this.temp123",this.temp);
             this.$api.deviceApi.saveAppClassType(this.nowCheckedItem.no, this.temp.name, this.nowCheckedItem.fatherno, this.nowCheckedItem.unitid, this.nowCheckedItem.sort, this.nowCheckedItem.devicetype, respon => {
					this.$message({type: 'success',message: '修改成功！'});
					this.dialogVisible = false
					this.getChannelAndVirtualDeviceTree()
				}, err => {
					this.$message({type: 'error',message: err});
				})
          } else {
            return false;
          }
        });
      },
	  
		
		
		// 删除
		deleteOperate() {
			
			if(this.nowCheckedItem == undefined) {
				this.$dialogMethod.showMessage("请先选中要删除的部分!")
				return
			}
			if(!isempty(this.nowCheckedItem.unitid) && this.nowCheckedItem.unitid != undefined) {
				this.$dialogMethod.showMessage("当前组不可删除!")
				return
			}
			 this.$confirm(`确定要删除 ${this.nowCheckedItem.name}吗?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
				}).then(() => {
					if(this.nowCheckedItem.entityName != undefined && this.nowCheckedItem.entityName == 'VirtualDevicePojo') {
						this.$api.deviceApi.deleteVirtualDevice(this.nowCheckedItem.no, respon => {
							this.$message({type: 'success',message: '删除设备：'+ this.nowCheckedItem.name +' 成功！'});
							this.getChannelAndVirtualDeviceTree()
							this.dialogVisible = false;
						}, err => {
							this.dialogVisible = false;
							this.$message({type: 'error',message: '删除设备失败！'+err});
						})
					}else{
						this.$api.deviceApi.deleteAppClassType(this.nowCheckedItem.no, respon => {
							this.$message({type: 'success',message: '删除组：'+ this.nowCheckedItem.name +' 成功！'});
							this.getChannelAndVirtualDeviceTree()
							this.dialogVisible = false;
						}, err => {
							this.dialogVisible = false;
							this.$message({type: 'error',message: '删除组失败！'+err});
						})
					}

				
				}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				});          
			});
			
			
		},
		// 刷新
		refresh() {
			this.getChannelAndDeviceTree()
			this.getChannelAndVirtualDeviceTree()
		},
		autoSelectMethod(item, index) {
			return item.entityName == 'Device'
		},
		isGroup(item) {
			return item.hasOwnProperty('next')
		},
		//左边树形结构点击
		checkItem(item) {
			console.log("点击",item);
			if(item.entityName == 'Device'){
				this.nowCheckedVariable = item
				this.nowDeviceVariableList = []
				this.getGenerallyVariableByDeviceNoLimit(item)
			}

		},
		//右边树形结构点击
		checkItemTwo(item) {
			console.log("右边点击",item);
			this.nowDeviceVariableListTwo = []
			this.nowCheckedItem = item
			this.isContainer = item.no == 0 ? true : false
			if(isempty(item.next) || item.next == undefined) {
				this.newSort = 1
			}else{
				var sort = 0
				for(let i = 0;i < item.next.length;i++) {
					if(item.next[i].sort > sort) {
						sort = item.next[i].sort
					}
				}
				this.newSort = sort + 1
			}
			if(item.entityName == 'VirtualDevicePojo') {
				this.isArea = false
				this.getVariableList(item)
			}else{
				this.isArea = true
			}
		},
		//导入虚设备
		addDeviceToRight() {
			this.$api.deviceApi.saveVirtualDevice(undefined, this.nowCheckedVariable.name, this.nowCheckedItem.no, this.nowCheckedVariable.no, this.nowCheckedVariable.parentarea, respon => {
				this.$message({type: 'success',message: '添加成功！'});
				this.getChannelAndVirtualDeviceTree()
			}, err => {
				this.$message({type: 'error',message: err});
			})
		},
		getChannelAndDeviceTree() {
			this.$api.deviceApi.getChannelAndDeviceTree(respon => {
				this.channelAndDeviceTree = [respon]
				// console.log("树形结构",this.channelAndDeviceTree);
			}, err => {
				this.$dialogMethod.showMessage(err)
			})
		},
		getChannelAndVirtualDeviceTree() {
			this.$api.deviceApi.getChannelAndVirtualDeviceTree(respon => {
				this.channelAndVirtualDeviceTree = [respon]
				console.log("虚拟设备",this.channelAndVirtualDeviceTree);
			}, err => {
				this.$dialogMethod.showMessage(err)
			})
		},
		getGenerallyVariableByDeviceNoLimit(item) {
			this.$api.channelApi.getGenerallyVariableByDeviceNoLimit(item.id, 1, 1000, respon => {
				this.nowDeviceVariableList = respon.data
			}, err => {
				this.$dialogMethod.showMessage(err)
			})
		},
		getVariableList(item) {
			this.$api.variableApi.getVariableList(item.no, respon => {
				this.nowDeviceVariableListTwo = respon
				console.log("右边树形结构nowDeviceVariableListTwo",respon);
			}, err => {
				this.$dialogMethod.showMessage(err)
			})
		},
		getAddedDeviceNos(list, arr) {
			for(let i = 0;i < list.length;i++) {
				if(list[i].entityName != undefined && list[i].entityName == 'VirtualDevicePojo') {
					arr.push(list[i].no)
				}else if(!isempty(list[i].next)) {
					this.getAddedDeviceNos(list[i].next, arr)
				}
			}
		}
    }
}
</script>

<style scoped lang="scss">
.con{
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        display: flex;
		.top-div {
			width: 100%;
			height: 477px;
			margin-bottom: 4px;
			background-color: #fff;
		}
		.xia-div {
          width: 100%;
		  height: calc(100% - 481px);
		  background-color: #fff;
		  
		}
		.mytree {
			width: 100%;
		}
		.con-left {
			width: 7.7rem;
			height: 100%;
			
            .top-tree {
				padding: 12px;
		    	box-sizing: border-box;
			}
			.mytable {
				padding: 12px;
				box-sizing: border-box;
				
			}
		}
		.con-middle {
			width: 140px;
			height: 100%;
			margin: 0px 4px;
			min-width: 140px;
           .top-btn , .xia-btn {
			   display: flex;
			   align-items: center;
			   justify-content: center;
			   img {
				margin-left: 10px;
			   }
				.left-add,.del{
				width: 116px;
				height: 32px;
				background-color: #368ED9;
				color: #fff;
				display: flex;
				align-items: center;
				justify-content: center;
				border-radius: 2px;
				}
				.del {
					background-color: #ED6547;
					margin-top: 20px;
				}
		   }
           .xia-btn {}
		}
		.con-right {
			width: 7.8rem;
			height: 100%;
			.Files-top {
				padding-bottom: 6px !important;
			}
			
             .top-tree {
				padding: 12px;
		    	box-sizing: border-box;
			}
			.mytable {
				padding: 12px;
				box-sizing: border-box;
				
			}
		}
}
    /deep/.el-dialog__header {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #E6E6E6;

      span {
        color: #67A3ED;
        font-size: 14px;
        font-weight: bold;
      }

      .el-icon-close {
        font-size: 20px !important;
      }

    }

    /deep/.el-dialog__footer {
      margin-top: 20px;
      text-align: right !important;
      border-top: 1px solid #E6E6E6;

      button {
        padding: 8px 17px;
      }
    }

    .demo-temp {
      display: flex;
      flex-wrap: wrap;
    }

    /deep/.el-form-item {
      display: flex;
      margin-left: 20px;
    }

    /deep/.el-form-item__label {
      white-space: nowrap;
      width: 86px;
    }

    /deep/.el-dialog__body {
      padding: 20px 0px 0px 20px !important;
    }


</style>
